/*
 * @Author: HuXiangYu 
 * @Date: 2023-01-03 17:36:26 
 * @Last Modified by: HuXiangYu
 * @Last Modified time: 2023-02-22 14:57:41
 */

// 导入组件，组件必须声明 name
import AceTableRender from './src/main.vue'
// 为组件添加 install 方法，用于按需引入
AceTableRender.install = function(Vue) {
	Vue.component(AceTableRender.name, AceTableRender)
}


export default AceTableRender 
